// report
import Report from "./report";

export const ModalContent = ({ data, printRef, reportRef }) => (
    <div className="cont-modal-info" ref={printRef}>
        <Report data={data} ref={reportRef} />
    </div>
);
